<app-choose-passphrase
  [defaultPassphrase]="defaultPassphrase"
  (formInitialization)="onPassphraseFormEvents($event)"
  (formChanges)="onPassphraseFormEvents($event)">
</app-choose-passphrase>
